import NewsPublishPopup from "./NewsPublishPopup";
import SecPublishPopup from "./SecPublishPopup";
import ManualPostPopup from "./ManualPostPopup";
import MapAndPostJobPopup from "./MapAndPostJobPopup";
import { ALL_POST_TYPES } from "../../../utils/AllLabels";

/**
 * SelectPublishPopup — Factory component for publish popups.
 *
 * Renders the appropriate publish popup based on `post_type` prop.
 * All extra props are forwarded to the rendered popup.
 */
const SelectPublishPopup = ({ post_type, ...props }) => {
    switch (post_type) {
        case ALL_POST_TYPES.NEWS:
            return <NewsPublishPopup {...props} />;
        case ALL_POST_TYPES.SEC_FILING:
            return <SecPublishPopup {...props} />;
        case ALL_POST_TYPES.JOB_UPDATES:
            return <MapAndPostJobPopup {...props} />;
        case 'ManuallyCreate':
            return <ManualPostPopup {...props} />;
        default:
            console.error(`SelectPublishPopup: post_type "${post_type}" is not supported.`);
            return null;
    }
};

export default SelectPublishPopup;
